<template>
  <div class="container">
    <div class="title">
      可提现金额
      <img
        class="icon"
        src="@/assets/img/icon-question.png"
        @click.stop="showTip(0)"
      />
    </div>
    <div class="profit">
      {{ deposit | formatAmount }}<span class="yuan">元</span>
    </div>
    <div>
      <div
        v-if="isExistWallet"
        class="btn"
        :data-bid="$BID.HOME_BILL_DEPOSIT_BTN_MC"
        :data-cid="cid"
        @click="onClickDeposit"
      >
        去提现
      </div>
      <div
        v-else-if="!isBypassAccount"
        class="btn"
        :data-bid="$BID.HOME_BILL_CREATE_WALLET_MC"
        :data-cid="cid"
        @click="handleClickCreateWallet"
      >
        立即开通钱包提现
      </div>
      <div
        v-else
        class="pass-account"
      >
        暂不支持子账号自主开通钱包，请联系业务经理。
      </div>
    </div>
    <div
      v-if="isExistWallet&&deposit<=0"
      class="record"
      :data-bid="$BID.HOME_BILL_DEPOSIT_RECORD_MC"
      :data-cid="cid"
      @click="onClickRecord"
    >
      查看提现记录
      <img
        class="icon"
        src="@/assets/img/arrow-right@2x.png"
      />
    </div>
    <div
      class="row"
      :data-bid="$BID.HOME_BILL_PROFIT"
      :data-cid="cid"
      @click="$router.push('settlement-tob/billList')"
    >
      <div class="month">
        <div class="title">
          本月预估收益
          <img
            v-if="!isAgent"
            class="icon"
            src="@/assets/img/icon-question.png"
            @click.capture.stop="showTip(1)"
          />
        </div>
        <div class="profit">
          {{ currentIncomeInYuan | formatAmount }}<span class="yuan">元</span>
          <img
            class="icon"
            src="@/assets/img/arrow-right@2x.png"
          />
        </div>
      </div>
      <div>
        <div class="title">
          昨日预估收益
        </div>
        <div class="profit">
          {{ yesterdayIncomeInYuan | formatAmount }}<span class="yuan">元</span>
          <img
            class="icon"
            src="@/assets/img/arrow-right@2x.png"
          />
        </div>
      </div>
    </div>
    <TipModal
      v-model="isShowTip"
      :title="tip.title"
    >
      {{ tip.msg }}
    </TipModal>
  </div>
</template>

<script>
import Dialog from 'vant/lib/dialog';
import { mapState, mapGetters } from 'vuex';
import WalletApi from '@/api/wallet';
import { ACCOUNT_ROLE } from '@/constants/common';
import TipModal from '@/components/TipModal';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';
import STATUS from '@/constants/status';
import { openPage } from '@/util/knb';

let clickTime = 0;

export default {
  name: 'HomeBill',
  components: {
    TipModal,
  },
  props: {
    accountRole: {
      type: Number,
      required: true,
    },
    existWallet: {
      type: Number,
      required: true,
      default: 0,
    },
    currentIncomeInYuan: {
      type: Number,
      required: true,
    },
    yesterdayIncomeInYuan: {
      type: Number,
      required: true,
    },
    deposit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isShowTip: false,
      tip: {},
    };
  },
  computed: {
    ...mapState(['bizlogintoken', 'isAgent']),
    ...mapGetters(['poiForWallet']),
    isBypassAccount() {
      return this.accountRole === ACCOUNT_ROLE.Bypass;
    },
    isExistWallet() {
      return Boolean(this.existWallet);
    },
    cid() {
      return this.$CID.Home;
    },
  },
  methods: {
    trackMV() {
      if (this.existWallet) {
        tracker.sendModuleView(BID.HOME_BILL_DEPOSIT_BTN_MV, this.cid);
        if (this.deposit <= 0) {
          tracker.sendModuleView(BID.HOME_BILL_DEPOSIT_RECORD_MV, this.cid);
        }
      } else if (!this.isBypassAccount) {
        tracker.sendModuleView(BID.HOME_BILL_CREATE_WALLET_MV, this.cid);
      }
    },
    onClickDeposit() {
      this.$emit('do-deposit');
    },
    async onClickRecord() {
      const { code, data, message } = await WalletApi.getHomePageUrl(this.poiForWallet);
      if (code === STATUS.SUCCESS) {
        openPage(data.url);
      } else {
        this.$dialog.toast(message || '获取钱包地址失败');
      }
    },
    async checkIsCanCreateWallet() {
      try {
        const { respMsg, data = {} } = await WalletApi.checkIsCanCreateWallet() || {};
        if (data.result) return true;

        throw new Error(respMsg);
      } catch (e) {
        Dialog({
          message: e.message || '未知错误，请联系业务员处理!',
          className: 'wallet-confirm-dialog',
        });
        return false;
      }
    },

    async handleClickCreateWallet() {
      if (new Date().getTime() - clickTime < 1000) {
        return;
      }
      clickTime = new Date().getTime();

      if (!this.isBypassAccount) {
        const isCanCreateWallet = await this.checkIsCanCreateWallet();

        if (isCanCreateWallet) {
          this.$router.push(`/createWallet?bizlogintoken=${this.bizlogintoken}`);
        }
      }
    },
    showTip(no) {
      const bid = no === 1 ? BID.HOME_BILL_PROFIT_QUESTION : BID.HOME_BILL_DEPOSIT_QUSTION;
      tracker.sendModuleClick(bid, null, { cid: this.cid });

      const arr = [
        {
          title: '提现说明',
          msg: '每月收益在次月15号（含）之后可提现。',
        },
        {
          title: '收益说明',
          msg: '预估收益以已出账账单为准。如果贵司无法提供发票，将从分成中扣除服务费',
        },
      ];
      this.isShowTip = true;
      this.tip = arr[no];
    },
  },
};
</script>

<style lang="scss" scoped>
.container  {
  position: relative;
  margin: 0 18px 18px;
  padding: 36px;
  border-radius: 12px;
  background: #FFF;
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #949494;
  .icon {
    margin-left: 6px;
  }
}
.profit {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 79px;
  font-weight: 500;
  font-size: 72px;
  color: rgba(0,0,0,0.84);
  letter-spacing: 0;

  .yuan {
    padding-top: 15px;
    padding-left: 12px;
    font-size: 30px;
  }
}

.btn {
  margin: 24px 0;
  height: 88px;
  line-height: 88px;
  background-color: #FFCC33;
  border-radius: 44px;
  font-size: 32px;
  color: #000000;
}
.pass-account {
  margin: 24px 0;
  font-size: 26px;
  color: #FF8800;
  letter-spacing: 0;
}

.icon {
  display: inline-block;
  height: 24px;
  width: 24px;
}

.record{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 36px;
}

.row {
  display: flex;
  .month {
    flex-basis: 355px;
  }
  .title {
    justify-content: flex-start;
  }
  .profit {
    justify-content: flex-start;
    font-size: 48px;
    .yuan {
      padding-top: 4px;
      padding-left: 8px;
    }
    .icon {
      margin-top: 7px;
    }
  }
}
</style>
